import {forwardRef, useMemo} from "react";
import {Project} from "../../../../../api/Projects";
import {Company} from "../../../../../api/Companies";
import {useUser} from "../../../../../misc/Permission";
import {PDF} from "../../../../../misc/pdf/parts/PDF";
import {ClientInfoContextProvider, PDFProjectContext} from "../../openings/OpeningsPDF";
import {useReadyCheck} from "../../../../../misc/pdf/UseReadyCheck";
import {CoverPage} from "../../../../../misc/pdf/parts/CoverPage";
import {Contact} from "../../../../../api/Contacts";
import {PDFInfo} from "../../../../../misc/pdf/PrintManager";
import {distinct} from "nate-react-api-helpers";
import {ExportColumn} from "../MakeSubmittal";
import {Div10Row} from "../../../../../api/QuoteDiv10";
import {PageItem} from "./PagesTab";
import {PageRenderProvider} from "../../../../../misc/pdf/parts/PageContext";
import {ContainerPage} from "../../../../../misc/pdf/parts/ContainerPage";
import {TitleTextBlock} from "../../../../../misc/pdf/parts/TitleTextBlock";
import * as React from "react";
import {RowsPage} from "./RowsPage";
import {hasPreambleContent, preambleToBlocks} from "../../../../../misc/richtext/preambleContent";


export function getDiv10PDF(props: {
    projectId: number;
    getData: () => Promise<{
        preamble: string;
        columns: ExportColumn[]
        project: Project;
        lastSubmission: string|null;
        client?: Company;
        clientContact?: Contact;
        data: Div10Row[];
        pages: PageItem[];
    }>
}): PDFInfo {

    return {
        name: `div10-export.pdf`,
        render: async (onReady, config) => {
            const d = await props.getData();

            if(d.pages.includes("cutSheets")) {
                config.adjust(input => {
                    input.appendCatalogPagesForProducts = input.appendCatalogPagesForProducts || [];
                    input.appendCatalogPagesForProducts.push(...d.data.map(d => d.product).filter(v => !!v));
                    input.appendCatalogPagesForProducts = distinct(input.appendCatalogPagesForProducts, v => v);
                    return input;
                })
            }

            return (
                <Div10PDF
                    pages={d.pages}
                    preamble={d.preamble}
                    columns={d.columns}
                    project={d.project}
                    lastSubmittal={d.lastSubmission}
                    client={d.client}
                    clientContact={d.clientContact}
                    data={d.data}
                    onReady={onReady}
                />
            );
        },
        serverInfo: {
            submissionForProject: props.projectId,
            submissionType: "div10",
        }
    }
}

export const Div10PDF = forwardRef(function(props: {
    lastSubmittal: string|null;
    project: Project;
    client?: Company;
    clientContact?: Contact;
    pages: PageItem[];
    data: Div10Row[];
    preamble: string;
    columns: ExportColumn[];
    onReady(): void;
}, ref: any) {
    const usr = useUser();

    const ready = useReadyCheck(props.onReady);
    ready.require(!!usr);

    const preamble = useMemo(() => preambleToBlocks(props.preamble || ""), [props.preamble]);

    return (
        <div ref={ref}>
            <PDF>
                <PDFProjectContext.Provider value={props.project}>
                    <ClientInfoContextProvider client={props.client} clientContact={props.clientContact}>
                        <CoverPage title="DIV 8 & DIV 10" lastSubmittal={props.lastSubmittal} />

                        {hasPreambleContent(props.preamble || "") && props.pages.includes("preamble") && <PageRenderProvider data={preamble} onReady={ready.section()}>
                            {info =>
                                <ContainerPage orientation="landscape">
                                    <TitleTextBlock title="PREAMBLE">
                                        {info.rows.map((d, index) => <div key={index.toString()} dangerouslySetInnerHTML={{__html: d}} />)}
                                    </TitleTextBlock>
                                </ContainerPage>}
                        </PageRenderProvider>}

                        {props.pages.includes("summary") && <RowsPage columns={props.columns} data={props.data} onReady={ready.section()} />}
                    </ClientInfoContextProvider>
                </PDFProjectContext.Provider>
            </PDF>
        </div>);
});